<template>
  <div class="info-window" @click="handleWindowClick">
    <icon class="close-button" :name="`fa fa-times`" size="sm" :onClick="handleCloseClick"/>
    <div class="aptitude-wrapper">
      <h4 class="info-window-title">Aptitud</h4>
      <div class="aptitude" :style="{ backgroundColor: isAgricultural ? '#4E9306' : '#E5A20A' }">
        <icon v-if="isAgricultural" :name="`fa fa-pagelines`" size="sm"/>
        <img v-else class="icon" src="../assets/icons/cow.svg" alt="Icono de vaca" />
        {{ aptitude }}
      </div>
    </div>
    <hr style="width: 100%; margin: 5px">
    <div class="services-wrapper" style="display: flex">
      <div class="services">
        <h4 class="info-window-title">Servicios</h4>
        <div v-for="(service, index) in services" :key="index" class="service">
          <ServicesIcon :service="service"/> {{ service }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ServicesIcon from './ServicesIcon.vue'
import { APTITUDES } from '../constants/aptitudes.js'

export default {
  components: {
    ServicesIcon
  },
  props: {
    aptitude: {
      type: String,
      require: true
    },
    services: {
      type: Array,
      require: true
    }
  },
  methods: {
    handleWindowClick() {
      this.$emit('windowClick');
    },
    handleCloseClick(event) {
      event.stopPropagation();
      this.$emit('closeButtonClick');
    }
  },
  computed: {
    isAgricultural () {
      return this.aptitude === APTITUDES.AGRICULTURAL
    }
  }
}
</script>
<style scoped>
.info-window {
  color: #000;
  padding: 1rem;
  font-family: "clearsans", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  align-content: center;
  overflow: hidden;
  height: 100%;
  cursor: pointer;
}

.close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 11;
}

.info-window-title {
  margin-left: 0.25rem;
  font-size: 1.2rem;
  font-weight: 600;
  line-height: 2rem;
  margin-right: 1rem;
  margin-bottom: 0;
  color: #000
}

.aptitude-wrapper {
  width: 100%;
  display: flex;
}

.aptitude {
  display: flex;
  height: 2rem;
  align-items: center;
  color: white;
  font-weight: 600;
  border-radius: 1rem;
  padding-right: 1rem;
  margin: 0.125rem;
}

.icon {
  width: 2rem;
  height: 2rem;
  padding: 0.5rem;
}

.services-wrapper {
  width: 100%;
}

.services {
  max-height: 7rem;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
}

.service {
  display: flex;
  height: 2rem;
  align-items: center;
  background-color: rgb(219, 219, 228);
  border-radius: 1rem;
  padding-right: 1rem;
  margin: 0.125rem;
}

</style>